import { render, staticRenderFns } from "./NagaizumiKaishuuView.vue?vue&type=template&id=b9a38cb2&scoped=true&"
import script from "./NagaizumiKaishuuView.vue?vue&type=script&lang=js&"
export * from "./NagaizumiKaishuuView.vue?vue&type=script&lang=js&"
import style0 from "./NagaizumiKaishuuView.vue?vue&type=style&index=0&id=b9a38cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a38cb2",
  null
  
)

export default component.exports